<template>
  <div>
    <!-- Vant 底部导航，fixed 固定在底部 -->
    <van-tabbar v-model="active" fixed @change="handleChange">
      <van-tabbar-item icon="wap-home" class="nav-item">首页</van-tabbar-item>
      <van-tabbar-item v-if="this.userType !== '03'" icon="wechat-moments" class="nav-item">真伪查询</van-tabbar-item>
      <van-tabbar-item v-if="this.userType !== '03'" icon="todo-list" class="nav-item">{{userType ==='01'?'球杆绑定':'球杆解绑'}}</van-tabbar-item>
      <van-tabbar-item v-if="this.userType === '03'" icon="todo-list" class="nav-item">分销返利</van-tabbar-item>
      <van-tabbar-item icon="friends" class="nav-item">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {memberInformation} from "@/api/mine";

export default {
  name: 'FooterNav',
  data() {
    return {
      active: 0, // 默认选中首页
      userType: ''
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    // 切换导航触发路由跳转
    handleChange(index) {
      //普通会员
      if(this.userType==='01'){
        const routes = ['/app_home', '/app_search', '/app_activation', '/app_mine'];
        this.$router.push(routes[index]);
      }else if(this.userType==='02'){//代理商
        const routes = ['/app_home', '/app_search_dls', '/unbind', '/app_mine'];
        this.$router.push(routes[index]);
      }else if(this.userType==='03'){//代理商
        const routes = ['/app_home', '/sale_list', '/app_mine'];
        this.$router.push(routes[index]);
      }
    },
    //获取登录人用户信息
    async getUserInfo() {
      const res = await memberInformation();
      if (res.code === 200 && res.data) {
        this.userType = res.data.userType;
      }
    },
  },
  watch: {
    // 路由同步导航选中状态
    '$route.path'(newPath) {
      if(this.userType==='01'){
        const routes = ['/app_home', '/app_search', '/app_activation', '/app_mine'];
        this.active = routes.indexOf(newPath) || 0;
      }else if(this.userType==='02'){
        const routes = ['/app_home', '/app_search_dls', '/unbind', '/app_mine'];
        this.active = routes.indexOf(newPath) || 0;
      }

    }
  }
};
</script>

<style scoped lang="scss">
// 底部导航安全区适配
.van-tabbar {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
// 导航项样式细化
.nav-item {
  font-size: 12px;
  .van-icon {
    font-size: 18px;
  }
}
</style>